<app-header></app-header>
<div class="section container-fluid pt-3 pb-4">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section pt-3 pb-5">
            <div class="d-flex flex-row justify-content-between">
                <span class="header">Create Blog</span>
                <div class="d-flex flex-row">
                    <button class="btn btn-cancel mr-2" (click)="clearData()">Cancel</button>
                    <button class="btn btn-theme"
                        [disabled]="!blogTitle.length || !blogImageFile || !blogContent.length || !tags.value.length"
                        (click)="publish()">
                        <div class="d-flex flex-row justify-content-center">
                            <div class="spinner-border loader" role="status" *ngIf="loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span class="align-self-center" *ngIf="!loading">Publish</span>
                        </div>
                    </button>
                </div>
            </div>
            <span class="input-label mt-3 mb-1">Blog title</span>
            <input class="form-control form-control-sm header-search" [(ngModel)]="blogTitle" type="text"
                placeholder="Blog title">
            <span class="input-label mt-3 mb-1">Blog hero image <span class="error-text">(Less than 100kb)</span></span>
            <div class="custom-file">
                <input (change)="readImage($event)" (click)="clearFile()" type="file" accept=".png,.jpg,.svg" required
                    class="custom-file-input" #blogImageInput id="customFile" name="blogName">
                <label *ngIf="blogImageName" class="custom-file-label" for="customFile">
                    {{ blogImageName }} <img src="../../../assets/Images/clear_circle.svg" class="clear-btn"
                        (click)="clearFile()" height="15" width="15">
                </label>
                <label *ngIf="!blogImageName" class="custom-file-label" for="customFile">Choose File</label>
            </div>
            <span class="input-label mt-3 mb-1">Tag</span>
            <mat-form-field class="w-100 mb-3">
                <mat-select #selectTag [formControl]="tags" multiple>
                    <mat-select-trigger>
                        <span *ngFor="let t of tags.value; let i = index">{{t.name}}<span
                                *ngIf="i != tags.value.length - 1">,
                            </span></span>
                    </mat-select-trigger>
                    <div>
                        <mat-option *ngFor="let tag of tagList" [value]="tag">{{tag.name}}</mat-option>
                    </div>
                    <footer class="mr-2 mb-2 float-right">
                        <button mat-flat-button color="primary" class="done-btn" (click)="closeDropdown()">Done</button>
                    </footer>
                </mat-select>
            </mat-form-field>
            <span class="input-label mb-1">Content</span>
            <textarea class="form-control header-search" [(ngModel)]="blogContent" rows="15"
                placeholder="Write here ..."></textarea>
        </div>
    </div>
</div>
<app-footer></app-footer>

<!-- Image Upload Modal Starts-->
<app-image-upload (blogImage)="setBlogImage($event)" [aspectRatio]="3 / 2" [mode]="'blog pic'"></app-image-upload>
<!-- Image Upload Modal Ends-->